// extracted by mini-css-extract-plugin
export default {"vote":"VotesIcon_vote__tQsy4","hr":"VotesIcon_hr__JM6yS","item":"VotesIcon_item__JOp6i"};